import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';

const SEO = ({ title, description, path = '/', type = 'website', keywords = '' }) => {
  const siteName = 'Binary Consultancy';
  const baseUrl = 'https://www.bincon.net';
  const fullTitle = title ? title + ' | ' + siteName : siteName + ' | Managed IT & Telecoms | Glossop';
  const fullUrl = baseUrl + path;

  useEffect(() => {
    document.title = fullTitle;
  }, [fullTitle]);

  return (
    <Helmet>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEO;
